// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__9yu1W","actionsCol":"EnrolledClinics_actionsCol__2cNXH"};